export enum OrderStatus {
  Draft = 'draft',
  Save = 'save',
  SaveToList = 'save-to-list',
  Quote = 'quote',
  Deposit = 'deposit',
  DepositPaying = 'deposit-now-paying',
  DepositToken = 'deposit-now-token',
  DepositCharged = 'deposit-now-charged',
  DepositPayLater = 'deposit-later',
  ExternalCheckout = 'external-checkout',
  Popup = 'popup',
}
